/**
 * Created by MinhQuan on 3/14/2016.
 */

//Angular ui boostrap
import 'angular-ui-bootstrap';

angular.module('common.helper', ['ui.bootstrap', 'common.config', 'common.filter.description', 'common.filter.specialCharacterToHtml', 'common.filter.decimalNumber']).factory('CommonHelper', function (CONSTANTS, $filter, $translate, $q, uibDatepickerPopupConfig) {
    var helper = {
        removeSpaceCharacters: function (str) {
            if(!str){
                return "";
            }
            return str.replace(/\s+/g, '');
        },
        getRestDateString: function (date) {
            if (!date) {
                return null;
            }

            //The date format yyyy-MM-dd is harded code intentionally because the rest api supports only this format.
            return $filter('date')(date, "yyyy-MM-dd");
        },
		getBookmarkDateString: function (date) {
			if (!date) {
				return null;
			}

			// The bookmarkDateFormat must have day as dd, month as MM, and year as yyyy
			return $filter('date')(date, CONSTANTS.bookmarkDateFormat);
		},
        getOffset: function (page) {
            return (page - 1) * CONSTANTS.rowsPerPage;
        },
        //This method is used for pagination on client side
        loadDataPerTablePage: function (data, page) {
            data = data instanceof Array ? data : [data];
            var pageSize = CONSTANTS.rowsPerPage;
            var fromIndex = (page - 1) * pageSize;
            var toIndex = 0;
            if (data.length >= (page * pageSize)) {
                toIndex = page * pageSize;
            } else {
                toIndex = data.length;
            }
            if (toIndex > fromIndex) {
                return data.slice(fromIndex, toIndex);
            }
            return null;
        },
        validateCommodityCode: function(commodityCode, tradeDirection) {
            var errorCode = null;
            if (!commodityCode) {
                return null;
            }
            var inputValue = this.removeSpaceCharacters(commodityCode);

            //Validate the commodity code matches the pattern "^[0-9 ]*$"
            if (!inputValue.match("^[0-9 ]*$")) {
                return "i8n.jsfconv.cc.notNumeric";
            }

            var valid = true;

            //Validate if the commodity code has an even number of characters
            if (inputValue.length % 2 !== 0) {
                valid = false;
            } else if ((inputValue.length > 10 && tradeDirection === 'I') ||
                ((tradeDirection === 'ER' || tradeDirection === 'E') && inputValue.length > 8)) {
                valid = false;
            }
            if (!valid) {
                if (tradeDirection === 'ER') {
                    errorCode = "i8n.jsfconv.cc.not8oreven.exportRefund";
                } else if (tradeDirection === 'E') {
                    errorCode = "i8n.jsfconv.cc.not8oreven.export";
                } else if (tradeDirection === 'I') {
                    errorCode = "i8n.jsfconv.cc.not10oreven.import";
                } else {
                    errorCode = "i8n.jsfconv.cc.noteven";
                }
            }
            return errorCode;
        },
		validateStringByPattern: function(value, pattern, errorCode) {
			// If input value exists and does not match pattern, errorCode will be returned.
			if (!value) {
				return null;
			}
			var inputValue = this.removeSpaceCharacters(value);

			if (!inputValue.match(pattern)) {
				return errorCode;
			}

			return null;
		},
        isTooltipEnable: function (descriptions) {
            var description = $filter('description')(descriptions);
            var descriptionWithHtml = $filter('specialCharacterToHtml')(description);
            if (descriptionWithHtml && descriptionWithHtml.length > CONSTANTS.maxDescriptionLength) {
                return true;
            }
            return false;
        },
        isDecimalNumber: function (value) {
            // Verify that the value is not undefined nor null
            if (value === undefined || value === null || ((typeof value) === "string" && this.removeSpaceCharacters(value) === '')) {
                return false;
            }

            // Input value must not contain thousandsSeparator.
            // Replace configured decimalSeparator by default decimalSeparator '.'
            var defaultDecimalValue = value.toString().replace(CONSTANTS.decimalSeparator, '.');

			// If default decimalSeparator '.' is used and the value contains separator ',',
			// the separator ',' must be replaced by '.'
			if (CONSTANTS.decimalSeparator === '.') {
				defaultDecimalValue = defaultDecimalValue.replace(',', '.');
			}

            if (isNaN(defaultDecimalValue) || !isFinite(defaultDecimalValue)) {
                return false;
            }

            return true;
        },
        getDecimalNumber: function (number) {
            if (!this.isDecimalNumber(number)) {
                return null;
            } else {
                // Replace configured decimalSeparator by default decimalSeparator '.'
				number = number.toString().replace(CONSTANTS.decimalSeparator, '.');

				// If default decimalSeparator '.' is used and the value contains separator ',',
				// the separator ',' must be replaced by '.'
				if (CONSTANTS.decimalSeparator === '.') {
					number = number.replace(',', '.');
				}

				// Remove redundant zero digits
				// Remove trailing zeros
				if (number.indexOf('.') >= 0) {
					number = number.toString().replace(/\.?0+$/, '');
				}
				// Remove leading zeros
				number = number.toString().replace(/^0+(?!\.|$)/, '');

				var maxLength = this.getDecimalNumberMaxLength(number, null, '.');
				while (number.length > maxLength) {
					number = number.substring(0, number.length - 1);
				}

				number = accounting.unformat(number);
            }

            return number;
        },
		truncateDecimalNumber: function (number, maxNumberFraction) {
			// The input number must be a decimal number
			var numberFraction = this.getNumberFraction(number);
			if (number === null || maxNumberFraction < 0 || numberFraction === 0) {
				return number;
			}

			// If the number fraction from the input decimal number is bigger than maxNumberFraction,
			// the input number will be truncated.
			if (numberFraction <= maxNumberFraction) {
				return number;
			}

			var truncatedNumberLength = number.toString().split('.')[0].length + 1 + maxNumberFraction;
			var truncatedNumber = accounting.unformat(number.toString().substring(0, truncatedNumberLength));
			return truncatedNumber;
		},
		getNumberFraction: function (number) {
			// The input number must be a decimal number
			var numberFraction = 0;
			if (number !== null && number.toString().indexOf('.') >= 0) {
				numberFraction = number.toString().split('.')[1].length;
			}

			return numberFraction;
		},
		getDecimalNumberMaxLength: function (number, thousandsSeparator, decimalSeparator) {
			// JavaScript Numbers can only handle accurate up to 15 digits.
			// If the number of digits exceeds 15, the decimal digits may not be correct.
			// Example: '9999999998.999999' -> 9999999998.999998
			var maxLength = 15;
			if (thousandsSeparator !== '' && number.toString().indexOf(thousandsSeparator) >= 0) {
				maxLength += number.toString().split(thousandsSeparator).length - 1;
			}
			if (number.toString().indexOf(decimalSeparator) >= 0) {
				maxLength++;
			}
			if (number.toString().indexOf('-') >= 0) {
				maxLength++;
			}

			return maxLength;
		},
		formatDecimalNumber: function (number, numberFraction, thousandsSeparator, decimalSeparator) {
			// This method avoids some cases accounting.formatNumber wrongly decimal part when the number has 15 digits or more.
			// For example: 99999999999999.9 -> '99999999999999.91'
			// The input number must be a decimal number
			var formattedNumber = accounting.formatNumber(number, numberFraction, thousandsSeparator, decimalSeparator);
			var maxLength = this.getDecimalNumberMaxLength(formattedNumber, thousandsSeparator, decimalSeparator);
			while (formattedNumber.length > maxLength) {
				formattedNumber = formattedNumber.substring(0, formattedNumber.length - 1);
			}

			return formattedNumber;
		},
        validateDeclarableCommodityCode: function(commodityCode, tradeDirection) {
            var errorCode = null;
            commodityCode = this.removeSpaceCharacters(commodityCode);
            if (commodityCode.length === 0) {
                errorCode = "i8n.error.commodity.commodityCode.required";
            } else if (!commodityCode.match("^[0-9 ]*$")) {
                errorCode=  "i8n.jsfconv.cc.notNumeric";
            } else if (tradeDirection === 'I' && commodityCode.length !== 10) {
                errorCode = "i8n.cc.import.not10";
            } else if (tradeDirection === 'E' && commodityCode.length !== 8) {
                errorCode = "i8n.cc.export.not8";
            }
            return errorCode;
        },
        validateAdditionalCode: function(adco){
            var inputValue = this.removeSpaceCharacters(adco);

            //Validate the additional code matches the pattern "^[0-9A-Z][0-9A-Z]{3}$"
            if (!inputValue.match("^[0-9A-Z][0-9A-Z]{3}$")) {
                return "i8n.jsfvalid.ac.illchar";
            }
            return null;
        },
        validateFootnote: function(footnote){
            var inputValue = this.removeSpaceCharacters(footnote);

            //Validate the footnote length and the pattern
            if (inputValue.length !== 5 && inputValue.length !== 8) {
                return "i8n.jsfvalid.footnote.illchar";
            }
            if (inputValue.length === 5 && (!(inputValue.substr(0,2)).match("^[0-9A-Z]{2}$") || !(inputValue.substr(2,4)).match("^[0-9]{3}$"))) {
                return "i8n.jsfvalid.footnote.illchar";
            }
            if (inputValue.length === 8 && (!(inputValue.substr(0,3)).match("^[0-9A-Z]{3}$") || !(inputValue.substr(3,7)).match("^[0-9]{5}$"))) {
                return "i8n.jsfvalid.footnote.illchar";
            }
            return null;
        },
        validateCertificate: function(certificate){
            var inputValue = this.removeSpaceCharacters(certificate);

            //Validate the certificate matches the pattern "^[0-9A-Z][0-9A-Z]{3}$"
            if (!inputValue.match("^[0-9A-Z][0-9A-Z]{3}$")) {
                return "i8n.jsfvalid.c.illchar";
            }
            return null;
        },
        validatePreferenceCodeMappingVersion: function(tradeDirection, preferenceCodeMappingVersion) {
            var errorCode = null;
            if (tradeDirection === 'I') {
                preferenceCodeMappingVersion = this.removeSpaceCharacters(preferenceCodeMappingVersion);
                if (preferenceCodeMappingVersion.length === 0) {
                    errorCode = "i8n.error.preferenceCodeMappingVersion.required";
                } else if (!preferenceCodeMappingVersion.match("^[1-2 ]*$")) {
                    errorCode=  "i8n.error.preferenceCodeMappingVersion.invalid";
                }
            }

            return errorCode;
        },
        loadImage: function(url, width, height, callBack, base64) {
        	
        	// this function is used to render base64 image that is used by pdf export
        	// it uses canvas to render image then convert to base 64.
        	// it needs image's url, original width and height of it
        	var canvas = document.createElement('canvas');
        	canvas.width  = width;
        	canvas.height = height;
        	
        	var context = canvas.getContext('2d');
        	  
            // load image from data url
            var imageObj = new Image();
            imageObj.onload = function() {
            	context.fillStyle = 'white';
            	context.fillRect(0, 0, width, height);
            	context.drawImage(this, 0, 0, width, height);
            	
            	if (base64) {
            		var options = {logo : canvas.toDataURL('image/jpeg')};
                	callBack(options);
            	} else {

                	var metaData = {logo : atob(canvas.toDataURL('image/jpeg').slice('data:image/jpeg;base64,'.length))};
                	callBack(metaData);
            	}
            };

            imageObj.src = url;
        },
        htmlTableToPdf: function(doc, table, options) {
        	
        	// width of header table.
        	var widths = [];
        	
        	// content of pdf.
            var body = [];

            // Table styles
            var tableHeaderBackgroundColor = '#19bd9c';
            var tableHeaderTextColor = '#ffffff';
            var tableTextColor = '#000000';
            
            // define width of headers according to html.
            // * means it would adjust it automatically
            for (var i = 0; i < table.rows[0].cells.length; i++) {
                var cell = table.rows[0].cells[i];
                widths.push('*');
            }

            // parse html table to extract content.
            // content is two dimension array
            // body[y] represents for rows, body[y][x] represents for cells
            for (var y = 0; y < table.rows.length; y++) {
            	body[y] = [];
                for (var x = 0; x < table.rows[y].cells.length; x++) {
                	
                	// extract cell content, remove all html tag and special characters. Only keep text content
                	var html = table.rows[y].cells[x].innerHTML;
                    var text = html.replace(/<(?:.|\n)*?>/gm, '');
                    text = this.decodeHTMLEntities(text);
                	text = text.replace(/(\r\n|\n|\r)/gm,"");
                	text = text.replace(/<br\s*[\/]?>/gi, "\r\n");
                	text = text.replace(/<(?:.|\n)*?>/gm, '');
                	
                	// alignment of text inside the cells. This is defined in html 
					var alignment = 'center';
					if (table.rows[y].cells[x].className.indexOf('text-right') != -1 ) {
					
						alignment = 'right';
					} else if (table.rows[y].cells[x].className.indexOf('text-left') != -1 ) {
					
						alignment = 'left';
					}

                    // Only set bold text to the label column of description table, do not fill background color
                    var isRowHeader = table.rows[y].cells[x].className.indexOf('row-header') != -1;
                    var isTableHeader = table.rows[y].cells[x].nodeName.toLowerCase() === 'th' && !isRowHeader;

					// parse colspan, rowspan property
					var colspan = table.rows[y].cells[x].getAttribute('data-colspan');
    	            var rowspan = table.rows[y].cells[x].getAttribute('data-rowspan');
    	            var width = table.rows[y].cells[x].getAttribute('data-width');

    	            if (width)
    	            	widths[x] = width;

    	            if (!colspan)
    	            	colspan = 1;

    	            if (!rowspan)
    	            	rowspan = 1;
    	            
    	            // Image cell. Using base64 image to replace html img tag
    	            if (html.indexOf('img/') != -1) {
    	            	
    	            	var imgData = 'flag';
    	            	var wi = 12;
    	            	var hi = 8;
    	            	var margin = 2;
    	            	if (html.indexOf('notchecked.png') != -1) {
    	            		
    	            		imgData = 'unchecked';
        	            	wi = 11;
        	            	hi = 11;
        	            	margin = 0;
    	            	} else if (html.indexOf('checked.png') != -1) {
    	            		
    	            		imgData = 'checked';
        	            	wi = 11;
        	            	hi = 11;
        	            	margin = 0;
    	            	} else if (html.indexOf('EU.png') != -1) {
    	            		
    	            		imgData = 'eu';
    	            	} else if (html.indexOf('unreleased.gif') != -1) {
    	            		
    	            		imgData = 'unreleased';
    	            		margin = 0;
    	            	}
    	            	
    	            	body[y].push({
                        	image: imgData,
                        	alignment : alignment,
                        	margin: [0, margin, 0, 0],
        		            width: wi,
        		            height: hi
                        });
    	            }
    	            // text cell
    	            else {
                        body[y].push({
                        	text: text,
                        	alignment : alignment,
                        	fontSize: isTableHeader ? 9 : 8.5,
                        	rowSpan: rowspan * 1,
                        	colSpan: colspan * 1,
                        	bold: isTableHeader || isRowHeader,
                            fillColor: isTableHeader ? tableHeaderBackgroundColor : null,
                            color: isTableHeader ? tableHeaderTextColor : tableTextColor
                        });
    	            }
                }
            }

            // Default table headerRows value = 1, which will be repeated on each pages.
            var headerRows = 1;
            if (options.headerRows || options.headerRows === 0) {
                headerRows = options.headerRows;
            }
            doc.push({
            	table: {
            		headerRows: headerRows,
                    dontBreakRows: false,
            		widths: widths,
            		body: body
            	},
            	layout: table.className.indexOf('no-border') != -1 ? 'noBorders' :
                    {
                        hLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.body.length) ? 0.5 : 0.5;
                        },
                        vLineWidth: function (i, node) {
                            return (i === 0 || i === node.table.widths.length) ? 0.5 : 0.5;
                        }
                    }
            });
        },
        decodeHTMLEntities: function(text) {
        	
            var entities = [
                ['apos', '\''],
                ['amp', '&'],
                ['lt', '<'],
                ['gt', '>'],
                ['nbsp', ' '],
                ['deg', '°']
            ];

            for (var i = 0, max = entities.length; i < max; ++i) {
				text = text.replace(new RegExp('&' + entities[i][0] + ';', 'g'), entities[i][1]);
			}

            return text;
        },
        printPlainDocument: function(options, mode) {
            let deferred = $q.defer();
            let pdfMake;
            System.import('pdfmake/build/pdfmake').then((module) => {
                pdfMake = module;
                System.import('pdfmake/build/vfs_fonts').then((pdfFonts) => {
                    pdfMake.vfs = pdfFonts.pdfMake.vfs;
                    // this function is used to export pdf using pdfmaker
                    // it has two modes, landscape and portrait
                    if (mode == 'l') {

                        mode = 'landscape';

                        // align title to center in landscape mode
                        options.size = {
                            title: {x: 390 - options.title.length},
                            headerWidth: [ '20%','56%','10%','10%']
                        };
                    } else {

                        mode = 'portrait';

                        // align title to center in portrait mode
                        options.size = {
                            title: {x: 270 - options.title.length},
                            headerWidth:[ '20%','45%','15%','20%']
                        };
                    }

                    // Print out valid on and created date at the top right of the report
                    var dateText = "";
                    var dateData = "";
                    if (options.validDate) {

                        dateText += $filter('translate')('i8n.common.report.validOn') + ":";
                        dateData += options.validDate;
                    }

                    dateText += "\n" + $filter('translate')('i8n.common.report.reportedAt') + ":";
                    dateData += "\n" + $filter('date')(new Date(), CONSTANTS.dateTimeFormat);

                    // prepare the document structure that has header, body and footer
                    var doc = {
                        header: function(currentPage, pageCount) {

                            var logoMargin = currentPage > 1 ? 30 : 30;
                            var titleMargin = (mode === 'portrait') && options.title.length > 30 ? 15 : 30;
                            return {
                                margin: 10,
                                columns: [
                                    {
                                        table: {
                                            widths: options.size.headerWidth,
                                            body: [
                                                [
                                                    {
                                                        image: 'logo',
                                                        width: CONSTANTS.pdfExport.logoWidth,
                                                        height: CONSTANTS.pdfExport.logoHeight,
                                                        margin: [logoMargin, 20]
                                                    },
                                                    {
                                                        text: options.title,
                                                        fontSize: 15,
                                                        bold: true,
                                                        alignment : "center",
                                                        margin: [0, titleMargin, 0, 0]
                                                    },
                                                    {
                                                        text: dateText,
                                                        alignment : "left",
                                                        fontSize: 9,
                                                        bold: true,
                                                        margin: [-5, 30]
                                                    },
                                                    {
                                                        text: dateData,
                                                        alignment : "left",
                                                        fontSize: 9,
                                                        bold: true,
                                                        margin: [0, 30]
                                                    }
                                                ]
                                            ]
                                        },
                                        layout: 'noBorders'
                                    }
                                ]
                            };
                        },
                        pageSize: 'A4',
                        pageMargins: [ 40, 40 + CONSTANTS.pdfExport.logoHeight, 40, 60 ],
                        content: options.contents,
                        pageOrientation: mode,
                        styles: {
                            defaultStyle: { font: CONSTANTS.printableFont }
                        },
                        footer: function(currentPage, pageCount) {
                            return { text: currentPage.toString(), alignment: 'center', margin: [0, 10, 0, 0] };
                        },
                        images: {
                            logo: options.logo,
                            flag: options.flag,
                            eu: options.eu,
                            checked: options.checked,
                            unchecked: options.unchecked,
                            unreleased: options.unreleased,
                            dutyCal: options.dutyCal
                        }
                    };

                    // download pdf, in safari it will open pdf in current window
                    pdfMake.createPdf(doc).download(options.title + '.pdf');
                    deferred.resolve();
            }, () => {
                    deferred.reject();
                });},
                () => {
                    deferred.reject();
                }
            );
            return deferred.promise;
        },
        printExcel: function(tableId, fileName, ws, processCell) {
            let deferred = $q.defer();
            let XLSX;
            let saveAs;
            System.import('xlsx').then((module) => {
                XLSX = module;
                System.import('file-saver').then((fileSaver) => {
                    saveAs = fileSaver.saveAs;

                    // this function is used to convert html table to json excel format
                    var generateArray =  (table) => {

                        var out = [];
                        var rows = table.querySelectorAll('tr');
                        var ranges = [];
                        for (var R = 0; R < rows.length; ++R) {
                            var outRow = [];
                            var row = rows[R];
                            var columns = row.querySelectorAll('td');
                            for (var C = 0; C < columns.length; ++C) {
                                var cell = columns[C];
                                var colspan = cell.getAttribute('colspan');
                                var rowspan = cell.getAttribute('rowspan');

                                var cellValue = this.decodeHTMLEntities(cell.innerText).replace(/<br\s*[\/]?>/gi, "\r\n").replace(/<(?:.|\n)*?>/gm, '');

                                //Skip ranges
                                for (var xz = 0; xz < ranges.length; xz++) {
                                    var range = ranges[xz];
                                    if(R >= range.s.r && R <= range.e.r && outRow.length >= range.s.c && outRow.length <= range.e.c) {
                                        for (let i = 0; i <= range.e.c - range.s.c; ++i) outRow.push(null);
                                    }
                                }

                                //Handle Row Span
                                if (rowspan || colspan) {
                                    rowspan = rowspan || 1;
                                    colspan = colspan || 1;
                                    ranges.push({s:{r:R, c:outRow.length},e:{r:R+rowspan-1, c:outRow.length+colspan-1}});
                                }

                                //Handle Value
                                outRow.push(cellValue !== "" ? cellValue : null);

                                //Handle Colspan
                                if (colspan) for (var k = 0; k < colspan - 1; ++k) outRow.push(null);
                            }
                            out.push(outRow);
                        }
                        return [out, ranges];
                    };

                    // this function is used to format cells base on data (string text, aligment) in the json structure
                    var sheet_from_array_of_arrays = function (data, opts) {

                        var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
                        for (let R = 0; R != data.length; ++R) {
                            for (let C = 0; C != data[R].length; ++C) {
                                if(range.s.r > R) range.s.r = R;
                                if(range.s.c > C) range.s.c = C;
                                if(range.e.r < R) range.e.r = R;
                                if(range.e.c < C) range.e.c = C;
                                var cell = {v: data[R][C] };
                                if(cell.v === null) continue;
                                var cell_ref = XLSX.utils.encode_cell({c:C,r:R});

                                cell.t = 's';

                                // first 3 columns are bold
                                if (processCell) {

                                    processCell(cell, R, C);
                                } else {

                                    if (R === 0 && C === 0) {
                                        cell.s = {
                                            font: {
                                                name: CONSTANTS.printableFont,
                                                bold: true,
                                                sz: 12
                                            },
                                            alignment: {
                                                horizontal: "center"
                                            }
                                        };
                                    } else if (R === 0 && C > 0) {
                                        cell.s = {
                                            font: {
                                                name: CONSTANTS.printableFont,
                                                bold: true
                                            },
                                            alignment: {
                                                horizontal: "right"
                                            }
                                        };
                                    } else if (R === 2) {
                                        cell.s = {
                                            font: {
                                                name: CONSTANTS.printableFont,
                                                bold: true,
                                                sz: 11
                                            },
                                            alignment: {
                                                horizontal: "center"
                                            },
                                            border: {
                                                top: { style: "thin", color: {rgb: "000000"}}
                                            }
                                        };
                                    } else if (R > 2) {
                                        cell.s = {
                                            font: {
                                                name: CONSTANTS.printableFont,
                                                sz: 10
                                            },
                                            alignment: {
                                                wrapText: 1,
                                                horizontal: "center"
                                            }
                                        };

                                        if (C === 2)
                                            cell.s.alignment = { horizontal: "left" };
                                        else if (C >= 4)
                                            cell.s.alignment = { horizontal: "right" };
                                    }
                                }

                                ws[cell_ref] = cell;
                            }
                        }
                        if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
                        return ws;
                    };

                    // excel constructor
                    var Workbook = function () {
                        if(!(this instanceof Workbook)) return new Workbook();
                        this.SheetNames = [];
                        this.Sheets = {};
                    };

                    // convert array to byte stream
                    var s2ab = function (s) {
                        var buf = new ArrayBuffer(s.length);
                        var view = new Uint8Array(buf);
                        for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                        return buf;
                    };

                    // format date
                    var datenum = function (v, date1904) {
                        if(date1904) v+=1462;
                        var epoch = Date.parse(v);
                        return (epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000);
                    };

                    // get table html from id
                    var theTable = document.getElementById(tableId);
                    var oo = generateArray(theTable);
                    var ranges = oo[1];

                    /* original data */
                    var data = oo[0];
                    var ws_name = "SheetJS";

                    var wb = new Workbook(), ws1 = sheet_from_array_of_arrays(data);

                    /* add ranges to worksheet */
                    ws1['!merges'] = ranges;

                    /* add worksheet to workbook */
                    wb.SheetNames.push(ws_name);
                    wb.Sheets[ws_name] = ws1;

                    fileName = fileName + ".xlsx";

                    // callback for safai because it does not support download attribute
                    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
                    if (isSafari) {

                        var base64Str = XLSX.write(wb, {bookType:'xlsx', bookSST: true, type: 'base64'});
                        var form = document.createElement('form');
                        form.action = 'output.xlsx';
                        form.method = 'POST';
                        form.style.display = 'none';

                        // name hidden
                        var input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = 'name';
                        input.value = fileName;
                        form.appendChild(input);

                        // file hidden
                        input = document.createElement('input');
                        input.type = 'hidden';
                        input.name = 'file';
                        input.value = base64Str;
                        form.appendChild(input);

                        var submit = document.createElement('input');
                        submit.type = 'submit';
                        submit.id = 'submitFile';
                        form.appendChild(submit);

                        document.body.appendChild(form);
                        document.forms[document.forms.length - 1].submit();
                        document.body.removeChild(form);
                    } else {

                        var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST: true, type: 'binary'});
                        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), fileName);
                    }
                    deferred.resolve();
                }, () => {
                    deferred.reject();
                });
            }, () => {
                deferred.reject();
            });

            return deferred.promise;
    	},
        compareDatesWithoutTime : function(date1, date2){
    	    var result = 0;
    	    if(!date1 && date2){
    	        result = 1;
            } else if (date1 && !date2){
                result = -1;
            } else if (date1 && date2){
                var moment1 = moment(date1);
                var moment2 = moment(date2);
                if(moment1.isAfter(moment2, 'day')){
                    result = 1;
                } else if (moment1.isSame(moment2, 'day')){
                    result = 0;
                } else {
                    result = -1;
                }
            }

            return result;
        },
        validateSimulationDate: function(simulationDate){
            var pastDateMoment = moment(CONSTANTS.pastDate, CONSTANTS.dateFormat.toUpperCase(), true);
            if (simulationDate && this.compareDatesWithoutTime(simulationDate, pastDateMoment.toDate()) <= 0){
                return  "sd.toolow_detail";
            }
            return null;
        },
        validateSimulationDateAfterOrBefore: function(simulationDate) {
            if (CONSTANTS.dateRestrictionEnabled) {
                var futureDateMoment = moment(new Date(), CONSTANTS.dateFormat.toUpperCase(), true);
                var pastDateMoment = moment(CONSTANTS.pastDate, CONSTANTS.dateFormat.toUpperCase(), true);
                if (simulationDate && this.compareDatesWithoutTime(simulationDate, futureDateMoment.toDate()) > 0) {
                    return "i8n.common.futureDate";
                } else if (simulationDate && this.compareDatesWithoutTime(simulationDate, pastDateMoment.toDate()) < 0) {
                    return "i8n.common.pastDate";
                }
            }
            return null;
        },
		getLanguageCode: function(locale){
            if (locale) {
                return locale.substring(0, 2);
            }
        	return locale;
		},
		getLogoImagePath: function(useLogoConfigFile){
			if (useLogoConfigFile && CONSTANTS.logoFileName){
				return 'img/' + CONSTANTS.logoFileName;
			}
			var result = 'img/logo_';
			var locale = $translate.use();
			if (locale.length === 2){
				result = result + locale + ".png";
			} else {
				result = result + locale.substring(3).toLowerCase() + ".png";
			}
			return result;
		},
		setDynamicLocale: function(tmhDynamicLocale) {
			// Change locale dynamically to load uib (Calendar popup) translation
			var langKey = $translate.use();
			if (langKey === undefined || langKey === null || langKey === '') {
				langKey = CONSTANTS.availableLanguages[0];
			}

			if (langKey.indexOf("_") >= 0) {
				// When langKey is "el_CY" or "el_GR", it needs be converted to "el-cy", "el-gr" to match the suffix of angular-locale files.
				var langKeyArray = langKey.split("_");
				tmhDynamicLocale.set(langKeyArray[0].toLowerCase() + "-" + langKeyArray[1].toLowerCase());
			} else {
				tmhDynamicLocale.set(langKey.toLowerCase());
			}
		},
		translateCalendarButtons: function() {
			// Translation for Calendar popup's buttons and Pagination's buttons
			$translate(['i8n.common.button.current',
				'i8n.common.button.clear',
				'i8n.common.button.Close']).then(function (translations) {
				uibDatepickerPopupConfig.currentText = translations['i8n.common.button.current'];
				uibDatepickerPopupConfig.clearText = translations['i8n.common.button.clear'];
				uibDatepickerPopupConfig.closeText = translations['i8n.common.button.Close'];
			});
		},
		parseInputDate: function(dateString) {
			dateString = this.removeSpaceCharacters(dateString);
			if (dateString === ""){
				return null;
			}

			// Parse date parameter when user enters direct url, and bookmark support.
			let dateMoment = new moment(dateString, CONSTANTS.bookmarkDateFormat.toUpperCase(), true);
			if (dateMoment.isValid()){
				return dateMoment.toDate();
			}

			// Parse date parameter when user opens a screen from lookup action or search result.
			// In this case, rest api date format "yyyy-MM-dd" is used.
			let inputDate = Date.parse(dateString);
			if (!isNaN(inputDate)) {
				return inputDate;
			}

			return null;
		},
        formatDate: function(dateObj, dateString) {
            // Datepicker allows any input date formats returned by method #getAltInputDateFormats
            // Method #formatDate reformats any input date to be displayed as CONSTANTS.dateFormat
            if (dateObj === null || dateObj === undefined) {
                return dateObj;
            }

            // If dateObj is a valid Date, format dateObj to be displayed as CONSTANTS.dateFormat
            if (dateObj instanceof Date && !isNaN(dateObj)) {
                let dateMoment = new moment(dateObj, CONSTANTS.dateFormat.toUpperCase(), true);

                // If user only inputs day and month dd/MM, the year of last valid dateObj will be used.
                // If the last dateObj is null or undefined, year 1900 will be used.
                // So we replace the year in both cases by the current year.
                if ((dateString && dateString.length <= 5) || dateMoment.year() === 1900) {
                    dateMoment.year((moment()).year());
                }
                return dateMoment.toDate();
            }

            return dateObj;
        },
        getAltInputDateFormats: function() {
            // Return alternative date formats, which support leading zeros of day and month,
            // all separators of '.', '/', '-',
            // and all customers:
            // Cyprus,Greece,Luxembourg: dd/MM/yyyy
            // Denmark:     ddMMyyyy
            // Estonia:     dd.MM.yyyy
            // Netherlands: d-M-yyyy
            // Sweden:      yyyy-MM-dd
            // Others:      ddMM, dd/MM, dd.MM, dd-MM
            //              yyyy/MM/dd, yyyy.MM.dd
            // If user does not input any of alternative date formats, the date value is undefined
            // If user inputs empty date, the date value is null
            return ["ddMMyyyy", "d!/M!/yyyy", "d!.M!.yyyy", "d!-M!-yyyy", "yyyy-M!-d!",
                    "ddMM", "d!/M!", "d!.M!", "d!-M!",
                    "yyyy/M!/d!", "yyyy.M!.d!"];
        },
		getValidSelectedItem: function(items, value, defaultValue){
			// If the input value does not exist in items, the default value will be returned.
			if (value) {
				for (let i = 0; i < items.length; i++) {
					if ((items[i].id && value === items[i].id) ||
						(items[i].type && value === items[i].type)) {
						return value;
					}
				}
			}

			return defaultValue;
		},
        getDistinctCodeList: function(codes, code) {
            // Get a distinct list of the given codes
            code = this.removeSpaceCharacters(code);
            return code ? array.union([code], codes) : array.union(codes);
        },
        getDistinctCodesString: function(codes, code) {
            // Build a distinct codes string of the given codes separated by ','
            let distinctCodes = this.getDistinctCodeList(codes, code);
            return distinctCodes.join(',');
        },
        setCookie: function(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            const expires = 'expires=' + d.toUTCString();
            document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
        },
        getCookie: function(name) {
            const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
            return v ? v[2] : null;
        }
    };
    return helper;
});



// WEBPACK FOOTER //
// ./app/common/helper/common-helper.js